export default __webpack_public_path__ + "static/media/footer-faqs-icon.6c68e92a.svg";